const featureAccessKeys = {

    TUTOR: 'becomeTutor'

};

export {
    featureAccessKeys
}